$(function(){
  $('.header-lang__main').click(function() {
    $('.header-lang').toggleClass('is-active');
  });
  $('.header-city__main').click(function() {
      showModal("modal-city");
    // $('.header-city').toggleClass('is-active');
    // $(".aside").removeClass("is-active");
  });


  $(document).on("click", ".header__menu", function(){
    $(".aside").addClass("is-active");
  })
  $(document).on("click", ".header__menu", function(){
    $(".aside").addClass("is-active");
  })
  $(document).on("click", ".close-aside", function(){
    $(".aside").removeClass("is-active");
  })

  let header = $('.header');
  let aside = $(".aside");
  let wrapper = document.querySelector(".wrapper");
  let html = $("html");
  $(document).on("click", ".navigate-item", function(e){
    e.preventDefault();
    let id = $(this).attr('href');
    let target = document.getElementById(id.split('#').join(''));
    if(!target){
      window.location = "/"
    }
    let wrapperTop = wrapper.getBoundingClientRect().top
    let targetTop = target.getBoundingClientRect().top
    let diff = Math.abs(wrapperTop - targetTop)
    if (target) {
      if(window.innerWidth >= 991){
        let element = $(".wrapper");
        element.stop().animate({scrollTop: $(wrapper).scrollTop() + targetTop - header.height()}, 500);
        scrolltop = 0;
        if(aside.hasClass("is-active")){
          aside.removeClass("is-active");
        }
      }else{
        $('body, html').stop().animate({scrollTop: $(id).offset().top - header.height()}, 500);
        $(".aside.is-active").removeClass("is-active");
      }
    }
  })
})
